import { getCrossTabCommunication } from '@/services/crossTabCommunication';
import { StorageService } from '@/services/storage';
import type { OutboxSend } from './types';

// Bumped whenever a stored outbox could no longer be read as the current
// shape; loadOutbox drops one that does not match.
export const OUTBOX_SCHEMA_VERSION = 3;

interface StoredOutbox {
  schemaVersion: number;
  sends: OutboxSend[];
}

/** The stored outbox's sends, or none when nothing usable is stored. */
export async function loadOutbox(): Promise<OutboxSend[]> {
  const json = await StorageService.getOutbox();
  if (!json) return [];
  try {
    const stored = JSON.parse(json) as StoredOutbox;
    if (
      stored?.schemaVersion !== OUTBOX_SCHEMA_VERSION ||
      !Array.isArray(stored.sends)
    ) {
      return [];
    }
    return stored.sends;
  } catch {
    return [];
  }
}

/**
 * Write the outbox's sends, replacing what was stored, and tell the app's
 * other tabs so their outboxes show the same.
 */
export async function saveOutbox(sends: readonly OutboxSend[]): Promise<void> {
  const stored: StoredOutbox = {
    schemaVersion: OUTBOX_SCHEMA_VERSION,
    sends: [...sends],
  };
  await StorageService.setOutbox(JSON.stringify(stored));
  getCrossTabCommunication().broadcastOutboxChange();
}
